import React, { useCallback, useEffect, useState } from "react"
import { ToastContainer, toast } from "react-toastify"
import { useNavigate } from "react-router-dom"
import { request } from "../../services/request"
import { CustomerDetail, Customernterface } from "../../services/authinterface"
import Table, { TableAction } from "../../components/common/Table"
import { useDebounce } from "../../hooks/useDebounce"
import moment from "moment"
import { useDispatch } from "react-redux"
import { changeloaderState } from "../../store/loaderSlice"
import { AppDispatch } from "../../store/store"
import PrimaryButton from "../../components/subComponents/PrimaryButton"
import { donwloadCSV, downloadPDF } from "../../utils/exportFunctions"
import { ResetIcon } from "../../icons/webSvg"

const Customers: React.FC = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const [customers, setCustomers] = useState<CustomerDetail[]>([])
  const [page, setPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(25)
  const [totalItems, setTotalItems] = useState(100)
  const [search, setSearch] = useState("")
  const debounceText = useDebounce(search, 500)
  const [sort, setSort] = useState("DESC")
  const [sortCol, setSortCol] = useState("createdAt")
  const [userType, setUserType] = useState("")
  const [userRole, setUserRole] = useState("")
  const [dateFilter, setDateFilter] = useState("")

  const fetchCustomers = useCallback(async () => {
    try {
      dispatch(changeloaderState(true))
      const params = {
        page: page,
        limit: rowsPerPage,
        search: debounceText,
        sort: sort,
        sortCol: sortCol,
        userType: userType,
        dateFilter: dateFilter,
        userRole: userRole
      }
      const response = await request<Customernterface>({
        url: "/adminCustomers/getCustomers",
        method: "POST",
        data: params,
      })

      if (response.data) {
        setCustomers(response.data)
        setTotalItems(response.total)
      } else {
        toast.error("Failed to fetch customers: " + response.message)
      }
    } catch (error: any) {
      toast.error(`${error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"}`)
    } finally {
      dispatch(changeloaderState(false))
    }
  }, [dispatch, page, rowsPerPage, debounceText, sort, userType, dateFilter, sortCol, userRole])

  useEffect(() => {
    fetchCustomers()
  }, [page, rowsPerPage, debounceText, sort, userType, dateFilter, fetchCustomers, userRole])

  useEffect(() => {
    if (debounceText) {
      setPage(1) // Reset to first page on search
    }
  }, [debounceText])

  const updateDemoUser = async (value: any) => {
    if(value?.role === "0"){
      const params = {
        demoUser: !value?.demoUser
      }
      try {
        const response = await request({
          url: `/adminCustomers/updateDemoUser/${value?.userId}`,
          method: "POST",
          data: params,
          // headers: { apikey: process.env.REACT_APP_API_KEY || "gunsens-api" }
        })
        if (response.data) {
          toast.success(response.message)
          fetchCustomers()
        } else {
          toast.error(response.message)
        }
      } catch (error: any) {
        toast.error(`${error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"}`)
      }
    }
    else{
      toast.error("Only the owner can update demo user status.")
    }
  }

  const columns = [
    {
      name: "Name",
      value: (customer: CustomerDetail) =>
        !customer.first_name && !customer.last_name
          ? "-"
          : (customer.first_name ? customer.first_name : "") +
          " " +
          (customer.last_name ? customer.last_name : ""),

      sort: true,
      id: "first_name",
    },
    {
      name: "Email",
      value: (customer: CustomerDetail) => customer.email,
      id: "email",
    },
    {
      name: "Role",
      value: (customer: CustomerDetail) =>
        customer.role === "0"
          ? "Owner"
          : customer.role === "1"
            ? "Admin"
            : customer.role === "2"
              ? "Viewer"
              : customer.role === "3"
                ? "Kid"
                : "Police",
      id: "role",
    },
    {
      name: "User Type",
      value: (customer: CustomerDetail) => (customer.is_police === true ? "Police" : "Civilian"),

      id: "Type",
    },
    {
      name: "Registered On",
      value: (customer: CustomerDetail) => moment(customer.createdAt).format("MMM-DD-YYYY HH:mm"),
      id: "createdAt",
    },
    {
      name: "Is Demo User?",
      value: (customer: CustomerDetail) => customer?.demoUser,
      id: "is_demo",
      type: "switch",
      onToggle: (value: any) => {
        updateDemoUser(value)
      }
    },
    // {
    //   name: "Next Billing SOS",
    //   value: (customer: CustomerDetail) => customer?.NextBillSOS || "-",
    //   id: "createdAt",
    // },
    {
      name:<div className="text-center">Buttons <br />Purchased | Provisioned</div>,
      value: (customer: CustomerDetail) => `${customer?.buttons_purchased || 0} | ${customer?.buttons_provisioned || 0}`,
      id: "buttons_purchased",
      className: "long-text-devices text-center"
    },
    {
      // name: "Sensors Purchased | Provisioned",
      name:<div className="text-center">Sensors <br />Purchased | Provisioned</div>,
      value: (customer: CustomerDetail) => `${customer?.sensors_purchased || 0} | ${customer?.sensors_provisioned || 0}`,
      id: "sensors_purchased",
      className: "long-text-devices text-center"
    },
  ]

  // const handlePaymentDetail = async (id: any) => {
  //   try {
  //     const response = await request({
  //       url: `/payment/newsetup/${id}`,
  //       method: "GET",
  //       headers: { apikey: process.env.REACT_APP_API_KEY || "gunsens-api" }
  //     })
  //     if (response.data) {
  //       toast.success(response.message)
  //     } else {
  //       toast.error(response.message)
  //     }
  //   } catch (error: any) {
  //     toast.error(`${error?.response?.data?.message ||
        // error?.message ||
        // "Something went wrong"}`)
  //   }
  // }
  
  const action: TableAction[] = [
    {
      label: "Info",
      // onClick: (row: CustomerDetail) => {
      //   navigate(`/customer/view/${row.id}`)
      // },
      isRedirect: true,
      link: (row: CustomerDetail) => `/customer/view/${row.id}`,
      // className: "table-btn-2",
      className: "table-btn-1",
      // icon: (
      //   <ViewIcon />
      // ),
    },
    // {
    //   label: "Edit",
    //   // onClick: (row: CustomerDetail) => {
    //   //   navigate(`/customer/edit/${row.id}`)
    //   // },
    //   isRedirect: true,
    //   link: (row: CustomerDetail) => `/customer/edit/${row.id}`,
    //   className: "table-btn-1",
    // },
    {
      label: "Invoices",
      // onClick: (row: CustomerDetail) => {
      //   navigate(`/customer/bills/${row.owner.id}`)
      // },
      link: (row: CustomerDetail) => `/customer/bills/${row.owner.id}`,
      isRedirect: true,
      className: "table-btn-1",
    },
    // {
    //   label: "Payment Detail",
    //   // onClick: (row: CustomerDetail) => {
    //   //   handlePaymentDetail(row.userId)
    //   // },
    //   link: (row: CustomerDetail) => `${process.env.REACT_APP_API_BASE_URL}/payment/newsetup/${row.userId}`,
    //   isRedirect: true,
    //   className: "table-btn-1",
    // },
  ]

  const addAction = {
    label: "Create",
    type: "button",
    onClick: (row: CustomerDetail) => {
      navigate(`/customer/add`)
    },
    className: "resetBtn",
  }

  const filters = [
    {
      label: "User type",
      type: "select",
      value: userType,
      onChange: (e: any) => {
        setUserType(e.target.value)
      },
      className: "userfilter",
      option: [
        { value: "", label: "All" },
        { value: "0", label: "User" },
        { value: "1", label: "Police" },
      ],
    },
    {
      label: "User role",
      type: "select",
      value: userRole,
      onChange: (e: any) => {
        setUserRole(e.target.value)
      },
      className: "userfilter",
      option: [
        { value: "", label: "All" },
        { value: "0", label: "Owner" },
        { value: "1", label: "Admin" },
        { value: "2", label: "Viewer" },
        { value: "3", label: "Kid" },
      ],
    },

    {
      label: "Registered Date",
      type: "date",
      value: dateFilter,
      onChange: (e: any) => {
        setDateFilter(e.target.value)
      },
      className: "datefilter",
    },

    {
      label: "Reset",
      type: "button",
      onClick: () => {
        setDateFilter("")
        setUserType("")
        setSearch("")
      },
      icon: (
        <ResetIcon />
      ),

      className: "resetBtn",
    },
  ]

  const fetchAllCustomers = async () => {
    try {
      const params = {
        page: 1,
        search: debounceText,
        limit: 100000,
        sort: sort,
        sortCol: sortCol,
        userType: userType,
        dateFilter: dateFilter,
        userRole: userRole,
      };
      const response = await request<Customernterface>({
        url: "/adminCustomers/getCustomers",
        method: "POST",
        data: params,
      });
      if (response.data) {
        return response.data;
      } else {
        toast.error("Failed to fetch all customers: " + response.message);
        return [];
      }
    } catch (error: any) {
      toast.error(`Error fetching all customers: ${error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"}`);
      return [];
    }
  };

  const exportCSV = async () => {
    const allData = await fetchAllCustomers();
    if (!allData.length) {
      toast.error("No data available to export.");
      return;
    }
    const headers = [
      "Sr No.",
      "Name",
      "Email",
      "Role",
      "Type",
      "Registered On",
    ];
    const rows = allData.map((customer, index) => [
      index + 1,
      !customer.first_name && !customer.last_name
        ? "-"
        : `${customer.first_name || ""} ${customer.last_name || ""}`,
      customer.email,
      customer.role === "0"
        ? "Owner"
        : customer.role === "1"
          ? "Admin"
          : customer.role === "2"
            ? "Viewer"
            : customer.role === "3"
              ? "Kid"
              : "Police",
      customer.is_police === true ? "Police" : "User",
      moment(customer.createdAt).format("MMM-DD-YYYY HH:mm"),
    ]);
    donwloadCSV(headers, rows, "Customers.csv");
  };

  const exportPDF = async () => {
    const allData = await fetchAllCustomers();
    if (!allData.length) {
      toast.error("No data available to export.");
      return;
    }
    const headers = [
      "Sr No.",
      "Name",
      "Email",
      "Role",
      "Type",
      "Registered On",
    ];
    const rows = allData.map((customer, index) => [
      index + 1,
      !customer.first_name && !customer.last_name
        ? "-"
        : `${customer.first_name || ""} ${customer.last_name || ""}`,
      customer.email,
      customer.role === "0"
        ? "Owner"
        : customer.role === "1"
          ? "Admin"
          : customer.role === "2"
            ? "Viewer"
            : customer.role === "3"
              ? "Kid"
              : "Police",
      customer.is_police === true ? "Police" : "User",
      moment(customer.createdAt).format("MMM-DD-YYYY HH:mm"),
    ]);
    downloadPDF(headers, rows, "Customers");
  };
  return (
    <section className=' dashboard-section dashboard-item '>
      <ToastContainer position='top-right' autoClose={2000} theme='light' />

      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <div className='dashboard-table-title-section'>
              <h2>Customers</h2>
              <div className='dashboard-table-title-right-side d-flex gap-2'>
                <PrimaryButton
                  label='Export CSV'
                  className='max-w-max-content'
                  onClick={exportCSV}
                />
                <PrimaryButton
                  label='Export PDF'
                  className='max-w-max-content'
                  onClick={exportPDF}
                />
              </div>
            </div>
          </div>
          <div className='col-12 mt-4'>
            <div className='table-container-main'>
              {/* <div className='table-details-section'></div> */}
              <Table
                rowData={customers}
                columns={columns}
                page={page}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                totalItems={totalItems}
                setSortColumn={setSortCol}
                setSortOrder={setSort}
                sortColumn={sortCol}
                sortOrder={sort}
                action={action}
                isSearch
                search={search}
                setSearch={setSearch}
                filterData={filters}
                addAction={addAction}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Customers
